import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UploadFileService } from 'src/app/core/services/upload-file.service';
import { TemplateType } from 'src/app/shared/enums/template-type';

@Component({
    selector: 'eci-sync-options-popup',
    templateUrl: './sync-options-popup.component.html',
    styleUrls: ['./sync-options-popup.component.scss']
})
export class SyncOptionsPopupComponent implements OnInit {

    listOfTypes: any[] = [];
    selectedType: number;

    get isUploadDisabled(): boolean {
        return this.selectedType === undefined;
    }

    get keysTypes(): Array<string> {
        let keys = Object.keys(TemplateType);
        return keys.slice(keys.length / 2);
    }

    constructor(
        private dialog: MatDialogRef<SyncOptionsPopupComponent>,
        public uploadFileSvc: UploadFileService,
    ) {
    }

    ngOnInit(): void {
        this.listOfTypes = this.keysTypes;
    }

    initSync(): void {
        this.dialog.close(this.selectedType);
    }
}
